import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { Eye, Trash2, MoreHorizontal } from 'lucide-react';
import { TypeBadge } from './TypeBadge';
import { AmountDisplay } from './AmountDisplay';
import { getTitleEnumValue } from '@/functions';
import type { IDataTableProps } from '@/interfaces';

export const DataTableMobileCard = ({ transaction, onViewDetails, onDelete, canDelete }: IDataTableProps) => {
	return (
		<div
			key={transaction._id}
			className="w-full p-4 border rounded-lg bg-card text-card-foreground shadow-xs hover:bg-muted/50 transition-colors"
		>
			<div className="flex items-start justify-between">
				<button
					type="button"
					className="space-y-2 flex-1 cursor-pointer text-left bg-transparent border-0 p-0"
					onClick={() => onViewDetails(transaction)}
				>
					<div className="flex flex-col items-start gap-1">
						<TypeBadge type={transaction.type} />
						<span className="text-xs text-muted-foreground font-medium px-0 py-0.5 rounded-full">{getTitleEnumValue('TransactionCategoryEnum', transaction.category) ?? transaction.category}</span>
					</div>
					<div className="text-sm font-medium line-clamp-1">{transaction.title}</div>
				</button>
				<div className="flex items-start gap-3">
					<div className="text-right">
						<AmountDisplay amount={transaction.amountEur} type={transaction.type} />
						<div className="text-xs text-muted-foreground mt-1">
							{format(new Date(transaction.occurredAt || transaction.createdAt || new Date()), 'dd MMM yyyy', { locale: fr })}
						</div>
					</div>
					{canDelete && onDelete && (
						<DropdownMenu>
							<DropdownMenuTrigger asChild>
								<Button variant="ghost" size="sm" className="h-8 w-8 p-0 -mt-1 -mr-2">
									<span className="sr-only">Open menu</span>
									<MoreHorizontal size={16} />
								</Button>
							</DropdownMenuTrigger>
							<DropdownMenuContent align="end">
								<DropdownMenuItem
									onClick={e => {
										e.stopPropagation();
										onViewDetails(transaction);
									}}
									className="cursor-pointer"
								>
									<Eye className="mr-2 h-4 w-4" />
									Voir les détails
								</DropdownMenuItem>
								<DropdownMenuItem
									onClick={e => {
										e.stopPropagation();
										onDelete(transaction);
									}}
									className="text-destructive cursor-pointer"
								>
									<Trash2 className="mr-2 h-4 w-4" />
									Supprimer
								</DropdownMenuItem>
							</DropdownMenuContent>
						</DropdownMenu>
					)}
				</div>
			</div>
		</div>
	);
};
